import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges } from "@angular/core";
import { ResponsiveService } from "@services/responsive.service";
import { Subscription } from "rxjs";

@Directive({
    selector: "[maxParentWidth]"
})
export class MaxParentWidthDirective implements OnInit, OnDestroy, OnChanges {
    @Input("maxParentWidth") maxParentWidth: number;

    // ---

    private originalDisplayStyle: string;
    private subscriptons = new Subscription();

    constructor(
        private readonly renderer: Renderer2,
        private readonly elementRef: ElementRef<HTMLElement>,
        private readonly responsiveService: ResponsiveService
    ) {
        this.cacheOriginalDisplayStyle();
    }

    ngOnInit(): void {
        this.subscriptons.add(this.responsiveService.currentWindowWidth$.subscribe(() => this.handleWindowResize()));
    }

    ngOnDestroy(): void {
        this.subscriptons.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.handleWindowResize();
    }

    // ---

    private handleWindowResize(): void {
        if (!this.maxParentWidth) {
            return;
        }

        const parentWidth = this.responsiveService.getParentWidthOfElementRef(this.elementRef);

        if (!parentWidth) {
            return;
        }

        this.calculateDisplayFromParentWidth(parentWidth);
    }

    private calculateDisplayFromParentWidth(parentWidth: number): void {
        if (this.maxParentWidth >= parentWidth) {
            this.responsiveService.removeHiddenElementStyling(this.elementRef, this.originalDisplayStyle, this.renderer);
            return;
        }

        this.responsiveService.addHiddenElementStyling(this.elementRef, this.renderer);
    }

    private cacheOriginalDisplayStyle(): void {
        this.originalDisplayStyle = this.elementRef?.nativeElement?.style?.display;
    }
}
